"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVelocityJson = exports.Velocity = exports.VelocityUnitTexts = exports.VelocityUnits = void 0;
const Quantity_1 = require("./Quantity");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
var VelocityUnits;
(function (VelocityUnits) {
    VelocityUnits["default"] = "m_s";
    VelocityUnits["km_h"] = "km_h";
    VelocityUnits["m_s"] = "m_s";
    VelocityUnits["fpm"] = "fpm";
    VelocityUnits["ft_s"] = "ft_s";
})(VelocityUnits = exports.VelocityUnits || (exports.VelocityUnits = {}));
exports.VelocityUnitTexts = {
    [VelocityUnits.default]: 'm/s',
    [VelocityUnits.km_h]: 'km/h',
    [VelocityUnits.m_s]: 'm/s',
    [VelocityUnits.fpm]: 'fpm',
    [VelocityUnits.ft_s]: 'ft/s',
};
class Velocity extends Quantity_1.Quantity {
    constructor() {
        super(...arguments);
        this.className = 'VelocityAccessor';
        this.defaultUnit = 'm_s';
        this.unitTexts = exports.VelocityUnitTexts;
    }
    static getUnitText(unit) {
        return exports.VelocityUnitTexts[unit];
    }
    static fromJson(q) {
        if (!(0, echain_shared_ts_utils_1.isValueInEnum)(VelocityUnits, q.Unit)) {
            throw new Error(`Velocity.fromJson: Unit not supported: ${q.Unit}`);
        }
        return new Velocity(q);
    }
    static m_s(v) {
        return new Velocity(v, VelocityUnits.m_s);
    }
    static km_h(v) {
        return new Velocity(v, VelocityUnits.km_h);
    }
    static fpm(v) {
        return new Velocity(v, VelocityUnits.fpm);
    }
    static ft_s(v) {
        return new Velocity(v, VelocityUnits.ft_s);
    }
    set m_s(v) {
        this.value = +v;
        this.unit = VelocityUnits.m_s;
    }
    get m_s() {
        switch (this.unit) {
            case VelocityUnits.km_h:
                return this.value / 3.6;
            case VelocityUnits.m_s:
                return this.value;
            case VelocityUnits.fpm:
                return this.value / 196.85;
            case VelocityUnits.ft_s:
                return this.value / 3.281;
        }
        throw new Error(`${this.className}.m_s: unknown unit ${this.unit}`);
    }
    set km_h(v) {
        this.value = +v;
        this.unit = VelocityUnits.km_h;
    }
    get km_h() {
        return this.unit === VelocityUnits.km_h ? this.value : this.m_s * 3.6;
    }
    set fpm(v) {
        this.value = +v;
        this.unit = VelocityUnits.fpm;
    }
    get fpm() {
        return this.unit === VelocityUnits.fpm ? this.value : this.m_s * 196.85;
    }
    set ft_s(v) {
        this.value = +v;
        this.unit = VelocityUnits.ft_s;
    }
    get ft_s() {
        return this.unit === VelocityUnits.ft_s ? this.value : this.m_s * 3.281;
    }
    clone() {
        return Velocity.fromJson(this.toJson());
    }
    getValue(unit) {
        switch (unit) {
            case 'default':
            case VelocityUnits.m_s:
                return this.m_s;
            case VelocityUnits.km_h:
                return this.km_h;
            case VelocityUnits.fpm:
                return this.fpm;
            case VelocityUnits.ft_s:
                return this.ft_s;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(unit);
        }
    }
}
exports.Velocity = Velocity;
Velocity.units = VelocityUnits;
const isVelocityJson = (l) => {
    return (0, Quantity_1.isQuantityJson)(l) && (0, echain_shared_ts_utils_1.isValueInEnum)(VelocityUnits, l.Unit);
};
exports.isVelocityJson = isVelocityJson;
//# sourceMappingURL=Velocity.js.map